<jqxWindow #windowJob [theme]="environment.tema" [position]="getFormPos(windowJob)" [width]="850" [height]="490" [zIndex]="50"
[autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false" (onExpand)="onExpand()" (onClose)="onClose()">
  <div class="formHeader" style="overflow-x: hidden;">
    {{translate('Tareas')}}
  </div>

  <div class="form" style="float: left; overflow-x: hidden;">
    <div style="float: left; margin-top: 6px; width: 100%;">
      <jqxGrid #gridJobs [theme]="environment.tema" [width]="'100%'" [source]="adapterJobs"
      [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
      [selectionmode]="'checkbox'" [columns]="columnsJobs" [showrowlines]="false" [showcolumnlines]="true"
      [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
      [showaggregates]="true" [rowsheight]="25" [columnsheight]="25" [enabletooltips]="true" [groupable]="true"
      (onRowselect)="onRowSelect($event)" (onRowunselect)="onRowUnselect($event)"
      (onRowclick)="onRowClick($event)" (onRowdoubleclick)="onRowdoubleclick($event)">
      </jqxGrid>
    </div>
    <div style="float: left; margin-top: 6px;" [hidden]="!usuario.Interno || rol.Nombre !== 'Administrador'">
      <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='26'
        [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/editar.png"'
        [value]="translate('Editar')" (onClick)="onEditarJob()">
      </jqxButton>
    </div>
  </div>
</jqxWindow>

<div #formJob></div>
